import { useState } from "react";
import { Nav } from "../components/Nav";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Stats } from "../components/Stats";
import { PracticeAreas } from "../components/PracticeAreas";
import { Attorney } from "../components/Attorney";
import { Locations } from "../components/Locations";
import { Footer } from "../components/Footer";
import { BookingModal } from "../components/BookingModal";
import { CallbackModal } from "../components/CallbackModal";

export default function Home() {
  const [bookingOpen, setBookingOpen] = useState(false);
  const [callbackOpen, setCallbackOpen] = useState(false);

  const openBooking = () => setBookingOpen(true);
  const openCallback = () => setCallbackOpen(true);

  return (
    <div data-testid="home-page" className="grain min-h-screen bg-navy-950">
      <Nav onBook={openBooking} onCallback={openCallback} />
      <main>
        <Hero onBook={openBooking} />
        <Marquee />
        <Stats />
        <PracticeAreas />
        <Attorney />
        <Locations />
      </main>
      <Footer onBook={openBooking} />
      <BookingModal open={bookingOpen} onClose={() => setBookingOpen(false)} />
      <CallbackModal open={callbackOpen} onClose={() => setCallbackOpen(false)} />
    </div>
  );
}
